import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const PANValidationModalUI = ({
    context, successMsg, errorList, setErrorList,
    // modes
    submitted,updateMode,
    // event handlers
    onSubmit, onCancelClick,
    // form fields
    pan, onPanChange, panError, setPanError,
}) => (
    <ModalFormUI
        context={context}
        titleLabel='PAN validation'
        buttonLabel='Validate'
        cancelLabel='Cancel'
        isOpen={updateMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputTextSF type='text' name='pan' label='PAN Number'
            value={pan} onChange={onPanChange} error={panError}
            setError={setPanError}
        />
    </ModalFormUI>
)

export default PANValidationModalUI

